interface OrderData {
  packingNo?: string | null;
}

interface OrderReviewTopProps {
  orderData?: OrderData | null;
}

const PackingOrderReviewTop = ({ orderData }: OrderReviewTopProps) => {
  if (!orderData || !orderData.packingNo || Number(orderData.packingNo) <= 0) {
    return null;
  }

  return (
    <div className="p-3 surface-card border-round shadow-1">
      <div className="flex align-items-center gap-3">
        <span className="text-900 font-semibold text-lg">Bin No:</span>
        <span className="text-700">{orderData.packingNo}</span>
      </div>
    </div>
  );


};

export default PackingOrderReviewTop;
